import { Component, effect, inject, model, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError, concatMap, EMPTY, finalize, from, map, of, switchMap, tap, throwError, toArray } from 'rxjs';
import { PlanFile } from 'src/app/models/plan-file.model';
import { SettlementsService } from 'src/app/services/settlements.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-tanque-create',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Combustible</h1>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block tank-menu">        
        <ul app-nav-tanques [currentView]="currentView" class="list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto tanque-container">
        @if (this.loading()) {
          <div class="loading">
          <fa-icon [icon]="icons.faSpinner" [animation]="'spin'"></fa-icon>
        </div>
        }
        <div class="d-flex mb-3">
          <div class="flex-fill ms-2">
            <h2 class="mt-2 mt-md-0 mb-0">Tanques</h2>
            <p class="text-muted" style="font-size: 14px;">Configura los tanques asignados a los edificios.</p>
          </div>
        </div>
        <div class="d-flex">
          <div class="flex-fill ms-auto">
            <div class="list-group rounded-4 rounded-md-5">
              <div class="list-group-item p-4">
                <app-form-tanque
                  [loading]="loading()"
                  (onLoading)="updateLoading($event)"
                  [permissions]="permissions"
                  (updateForm)="createTanque($event)"
                  (newEmptyFile)="newFile()"
                  [(planFiles)]="files"
                ></app-form-tanque>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  `,
  styleUrls: ['./tanque-create.component.scss']
})
export class TanqueCreateComponent {
  files = model<PlanFile[] | null>(null);
  icons = inject(IconsService);
  loading = signal<boolean>(false);
  profile: any;
  permissions: any;
  currentView: string = 'tanques';

  payload: any = {
    page: 1,
    per_page: 100,
  };
  storageService = inject(StorageService);
  constructor(
    private router: Router,
    private store: SettlementsService,
    private toastr: ToastrService
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
    this.payload.id = this.profile ? this.profile.id : 0;
    effect(() => {
      const files = this.files();
      console.log(
        '%cFiles updated =>',
        'background: #FFFF00; color: black; font-weight: bold;',
        files
      );
    });
  }


  newFile() {
    const emptyFile: PlanFile = {
      uiId: uuidv4()
    } as PlanFile;
    this.files.update((prev) => prev ? ([...prev, emptyFile]) : [emptyFile]);
  }

  updateLoading(value: boolean) {
    this.loading.set(value);
  }

  createTanque(data: any) {
    this.loading.set(true);
    const { trajectory_distance, ...tanquePayload } = data;
    this.store.createTanque(tanquePayload).pipe(
      tap(() => {
        this.toastr.success('Tanque creado', 'Tanque creado correctamente');
        this.router.navigate(['combustibles/tanques']);
      }),
      catchError(error => {
        this.toastr.error('Error', 'Error al crear tanque');
        return throwError(() => error);
      }),
      switchMap((responseTanque: any) => {
        if (this.files() === null || this.files()?.length === 0) {
          return EMPTY;
        }
        return from(this.files()!).pipe(
          concatMap((f: PlanFile) => {
            const formData = this.plansFormData(f);
            return this.store.saveTankPlans(responseTanque.data.id, formData).pipe(
              tap(response => {
                this.files.update((prev: PlanFile[] | null) => {
                  if (!prev) return null;
                  let current = prev.find(file => file.uiId === f.uiId);
                  current = {...current, ...response};
                  const newList = [...prev.filter(file => file.uiId !== f.uiId), current as PlanFile];
                  
                  return newList;
                })
              }),
              catchError(err => {
                console.warn(err);
                return EMPTY;
              })
            )
          }),
          toArray()
        );
      }),
      finalize(() => this.loading.set(false))
    ).subscribe({
      next: (res) => {
        this.toastr.success(
          'Planos agregados',
          `Los planos han sido agregados al tanque`
        );
      }
    });
  }

  plansFormData(plan: PlanFile): FormData {
    const file = plan.file!;
    const formData = new FormData();
    formData.append('blueprint[name]', file.name);
    formData.append('blueprint[file]', file);
    return formData;
  }

}
